export const AGENT_LANGUAGE_OPTIONS = [
  { code: 'es', chip: 'ES', labelKey: 'AgenticChatFlow.LanguageSpanish', native: 'Español' },
  { code: 'ca', chip: 'CA', labelKey: 'AgenticChatFlow.LanguageCatalan', native: 'Català' },
  { code: 'en', chip: 'EN', labelKey: 'AgenticChatFlow.LanguageEnglish', native: 'English' },
  { code: 'pt', chip: 'PT', labelKey: 'AgenticChatFlow.LanguagePortuguese', native: 'Português' },
];

export default AGENT_LANGUAGE_OPTIONS;
